import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  fetchAllData,
  fetchData,
  fetchUpdateData,
  uploadImage,
} from "../../helpers/externapi";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { fetchConfigValues } from "../../Commoncomponents/CommonComponents";

export default function SmartClinicRegistration() {
  const location = useLocation();
  const profileFromLocation = location.state ? location.state.profile : null;
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);
  const [states, setStates] = React.useState([]);
  const [districts, setDistricts] = React.useState([]);
  const [errors, setErrors] = useState({});
  const [isEditForm, setIsEditForm] = useState(false);
  const [clinicId, setClinicId] = React.useState("");
  const [isAddForm, setIsAddForm] = React.useState(false);
  const [formError, setFormError] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedStateId, setSelectedStateId] = useState(null);
  const [selectedImage, setSelectedImage] = React.useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [base64, setBase64] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [mandals, setMandals] = useState([]);
  const [villages, setVillages] = useState([]);
  const [selectedDistrictId, setSelectedDistrictId] = useState(null);
  const [filteredMandals, setFilteredMandals] = useState([]);
  const [filteredVillages, setFilteredVillages] = useState([]);
  const [newMandalName, setNewMandalName] = useState("");
  const [isAddingMandal, setIsAddingMandal] = useState(false);
  const [newVillageName, setNewVillageName] = useState("");
  const [isAddingVillage, setIsAddingVillage] = useState(false);

  let UserId = localStorage.getItem("UserId");

  const initialFormData = {
    SmartClinicName: "",
    SmartClinicImage: "",
    AddressLine1: "",
    AddressLine2: "",
    Village: "",
    Mandal: "",
    City: "",
    StateId: "",
    DistrictId: "",
    Area: "",
    Colony: "",
    Pincode: "",
    Latitude: "",
    Longitude: "",
    SmartClinicId: ""
  };

  const [formData, setFormData] = useState(initialFormData);
  const [imageUrl, setImageUrl] = useState('');

 

  useEffect(() => {
    const getImageUrl = async () => {
      const { userImagesBucketlink } = await fetchConfigValues();
      setImageUrl(userImagesBucketlink || '');
    };

    getImageUrl();
  }, []);

  useEffect(() => {
    if (profileFromLocation) {
      setIsEditForm(true);
      setClinicId(profileFromLocation.SmartClinicId);
      setFormData(profileFromLocation);
      setSelectedStateId(profileFromLocation.StateId);


      if (profileFromLocation.SmartClinicImage) {
        setSelectedImage(profileFromLocation.SmartClinicImage);

      }
    } else {
      setIsAddForm(true);
      setFormData(initialFormData);
    }
  }, [profileFromLocation]);

  useEffect(() => {
    const getStates = async () => {
      setLoading(true);
      const statesData = await fetchData("States/all", { skip: 0, take: 0 });
      setStates(statesData);
      setLoading(false);
    };

    getStates();
  }, []);

  useEffect(() => {
    const getDistricts = async () => {
      if (selectedStateId !== null) {
        setLoading(true);
        const districtsData = await fetchAllData(
          `Districts/GetByStateId/${selectedStateId}`
        );
        setDistricts(districtsData);
        setLoading(false);
      } else {
        setDistricts([]);
      }
    };
    getDistricts();
  }, [selectedStateId]);

  const getMandals = async (districtId) => {
    if (!districtId) {
      console.error("District ID is undefined or null");
      setFilteredMandals([]);
      return;
    }

    try {
      setLoading(true);
      const parsedDistrictId = parseInt(districtId, 10) || districtId;
      const url = `Mandal/GetMandalsByDistrictId/${parsedDistrictId}`;
      const response = await fetchAllData(url);

      if (response && Array.isArray(response)) {
        setFilteredMandals(response);
      } else {
        setFilteredMandals([]);
        console.error("Invalid mandal data received", response);
      }
    } catch (error) {
      console.error("Error fetching mandals:", error);
      setFilteredMandals([]);
    } finally {
      setLoading(false);
    }
  };

  const getVillages = async (mandalId) => {
    if (!mandalId || !formData.DistrictId) {
      setFilteredVillages([]);
      return;
    }

    try {
      setLoading(true);
      const url = `Village/GetVillagesByMandalId/${mandalId}`;
      const response = await fetchAllData(url);

      if (response && Array.isArray(response)) {
        setFilteredVillages(response);
      } else {
        setFilteredVillages([]);
        console.error("Invalid village data received", response);
      }
    } catch (error) {
      console.error("Error fetching villages:", error);
      setFilteredVillages([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (formData.DistrictId) {
      setFormData((prev) => ({
        ...prev,
        MandalName: "",
        VillageName: "",
      }));

      getMandals(formData.DistrictId);
      setFilteredVillages([]);
    } else {
      setFilteredMandals([]);
      setFilteredVillages([]);
    }
  }, [formData.DistrictId]);

  useEffect(() => {

      const selectedMandal = filteredMandals.find(
        (m) => m.MandalName === formData.Mandal
      );
      if (selectedMandal) {
        getVillages(selectedMandal.MandalId);
      } else {
        setVillages([]);
      }
    
  }, [formData.Mandal]);


  const handleAddMandal = async () => {
    if (!newMandalName.trim()) return;
    if (!formData.DistrictId) {
      return;
    }

    setLoading(true);
    try {
      const response = await fetchData("Mandal/add", {
        DistrictId: parseInt(formData.DistrictId),
        StateId: parseInt(formData.StateId),
        MandalName: newMandalName,
        CreatedBy: UserId,
      });

      if (response && (response.MandalId || response.mandalId)) {
        const newMandalId = response.MandalId || response.mandalId;
        const newMandal = {
          mandalId: newMandalId,
          MandalName: newMandalName
        };

        setFilteredMandals((prev) => [...prev, newMandal]);
        setFormData((prev) => ({
          ...prev,
          Mandal: newMandalName,
          Village: "",
        }));

        setNewMandalName("");
        setIsAddingMandal(false);
      } else {
        console.error("Failed to add mandal - invalid response:", response);
      }
    } catch (error) {
      console.error("Error adding mandal:", error);
    } finally {
      setLoading(false);
    }
  };

 const handleAddVillage = async (e) => {
     e.preventDefault();
     if (!newVillageName.trim()) return;
 
     const selectedMandal = filteredMandals.find(m => m.MandalName === formData.Mandal);
     const mandalId = selectedMandal ? selectedMandal.MandalId : null;
 
     if (!mandalId) {
       console.error("Please select a valid Mandal first.");
       return;
     }
 
     const newVillage = {
       MandalId: mandalId,
       MandalName: formData.Mandal,
       DistrictId: selectedDistrictId,
       StateId: formData.StateId,
       VillageName: newVillageName,
       CreatedBy: UserId,
     };
 
     setLoading(true);
     try {
       const response = await fetchData("Village/add", newVillage);
 
       if (response) {
         const villageId = response.VillageId || `temp-${Date.now()}`;
 
         setVillages(prev => [...prev, {
           VillageId: villageId,
           VillageName: newVillageName,
           MandalId: mandalId
         }]);
 
         await getVillages(mandalId);
         setFormData({ ...formData, Village: newVillageName });
         setNewVillageName("");
         setIsAddingVillage(false);
       } else {
         console.error("Failed to add village.");
       }
     } catch (error) {
       console.error("Error adding village:", error);
     } finally {
       setLoading(false);
     }
   };

  const handleBackToView = () => {
    if (profileFromLocation && profileFromLocation.SmartClinicId) {
      navigate(`/smartclinics/details/${profileFromLocation.SmartClinicId}`);
    } else {
      navigate("/smartclinics/list");
    }
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setErrors({});
    setFormError({});
    setSelectedImage(null);
    setBase64(null);
  };

  const validateForm = async () => {
    let err = {};

    if (formData.SmartClinicName === "") {
      err.SmartClinicName = "Please Enter Smart Clinic Name";
    } else if (formData.SmartClinicName.length < 3) {
      err.SmartClinicName = "Smart Clinic Name must be greater than 2 letters";
    }

    if (formData.AddressLine1.length < 2) {
      err.AddressLine1 = "Please Enter Your Address";
    }

    if (formData.City && formData.City.trim() === "") {
      err.City = "Please Enter Your City name";
    }

    if (!formData.DistrictId || formData.DistrictId.length === 0) {
      err.DistrictId = "Please Select Your District";
    }

    if (!formData.StateId || formData.StateId.length === 0) {
      err.StateId = "Please Select Your State";
    }

    if (
      typeof formData.Pincode === "string" &&
      formData.Pincode.trim() === ""
    ) {
      err.Pincode = "Please enter a valid 6-digit pin code";
    } else if (
      typeof formData.Pincode === "string" &&
      formData.Pincode.trim().length !== 6
    ) {
      err.Pincode = "Pincode must be 6 digits";
    }

    if (formData.City === "") {
      err.City = "Enter city Name";
    } else if (formData.City && formData.City.trim() !== "") {
      const isValidCity = /^[A-Za-z\s]+$/.test(formData.City);
      if (!isValidCity) {
        err.City = "City name should contain only alphabetic characters";
      }
    }

    setFormError({ ...err });
    const isValid = Object.keys(err).length === 0;
    return isValid;
  };

  const onChangeHandler = (event) => {
    const { name, value, files } = event.target;
    let updatedValue = value;

    if (name === "SmartClinicImage") {
      updatedValue = files[0];
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: updatedValue,
    }));
    setFormError((prevError) => ({
      ...prevError,
      [name]: "",
    }));

    if (name === "StateId") {
      setSelectedStateId(value);
      setFormData((prevFormData) => ({
        ...prevFormData,
        DistrictId: "",
        Mandal: "",
        Village: "",
      }));
    }
    if (name === "DistrictId") {
      setSelectedDistrictId(value);
      setFormData((prevFormData) => ({
        ...prevFormData,
        Mandal: "",
        Village: "",
      }));
    }
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    const isValid = await validateForm();
    if (isValid) {
      try {
        setSubmitLoading(true);

        let SmartClinicData;

        if (!formData.SmartClinicId) {
          // Create new smart clinic
          SmartClinicData = await fetchData("lambdaAPI/SmartClinics/add", {
            SmartClinicName: formData.SmartClinicName,
            SmartClinicImage: base64 ? base64.split("base64,")[1] : "",
            AddressLine1: formData.AddressLine1,
            AddressLine2: formData.AddressLine2,
            Village: formData.Village,
            Mandal: formData.Mandal,
            City: formData.City,
            StateId: parseInt(formData.StateId),
            DistrictId: parseInt(formData.DistrictId),
            Area: formData.Area,
            Colony: formData.Colony,
            Pincode: formData.Pincode,
            AddedBy: UserId,
          });

          setSnackbarMessage("Smart Clinic Added Successfully");
        } else {
          // Update existing smart clinic (you'll need to implement update API)

          const clinicUpdateData = [
            {
              columnName: "SmartClinicName",
              columnValue: formData.SmartClinicName,
              tableName: "SmartClinics",
              tableId: formData.SmartClinicId,
              UpdatedBy: UserId,
            },
            {
              columnName: "AddressLine1",
              columnValue: formData.AddressLine1,
              tableName: "SmartClinics",
              tableId: formData.SmartClinicId,
              UpdatedBy: UserId,
            },
            {
              columnName: "AddressLine2",
              columnValue: formData.AddressLine2,
              tableName: "SmartClinics",
              tableId: formData.SmartClinicId,
              UpdatedBy: UserId,
            },
            {
              columnName: "Village",
              columnValue: formData.Village,
              tableName: "SmartClinics",
              tableId: formData.SmartClinicId,
              UpdatedBy: UserId,
            },
            {
              columnName: "Mandal",
              columnValue: formData.Mandal,
              tableName: "SmartClinics",
              tableId: formData.SmartClinicId,
              UpdatedBy: UserId,
            },
            {
              columnName: "City",
              columnValue: formData.City,
              tableName: "SmartClinics",
              tableId: formData.SmartClinicId,
              UpdatedBy: UserId,
            },
            {
              columnName: "StateId",
              columnValue: parseInt(formData.StateId),
              tableName: "SmartClinics",
              tableId: formData.SmartClinicId,
              UpdatedBy: UserId,
            },
            {
              columnName: "DistrictId",
              columnValue: parseInt(formData.DistrictId),
              tableName: "SmartClinics",
              tableId: formData.SmartClinicId,
              UpdatedBy: UserId,
            },
            {
              columnName: "Area",
              columnValue: formData.Area,
              tableName: "SmartClinics",
              tableId: formData.SmartClinicId,
              UpdatedBy: UserId,
            },
            {
              columnName: "Colony",
              columnValue: formData.Colony,
              tableName: "SmartClinics",
              tableId: formData.SmartClinicId,
              UpdatedBy: UserId,
            },
            {
              columnName: "Pincode",
              columnValue: formData.Pincode,
              tableName: "SmartClinics",
              tableId: formData.SmartClinicId,
              UpdatedBy: UserId,
            },
          ];

          const clinicUpdateResponse = await fetchUpdateData(
            "lambdaAPI/Update/CommonUpdate",
            clinicUpdateData
          );

          setSnackbarMessage("Smart Clinic Updated Successfully");
        }

        const clinicId =  formData.SmartClinicId || SmartClinicData.data?.smartClinicId || SmartClinicData.smartClinicId || profileFromLocation?.SmartClinicId;

        // If there's a new image and we have a clinic ID, upload it separately

       
        if (clinicId && base64) {
          await handleImageUpload(clinicId);
        }


        navigate(`/smartclinics/details/${clinicId}`);
        setSnackbarOpen(true);
      } catch (error) {
        console.error("Error during submission:", error);
        setSnackbarMessage("Submission Failed");
        setSnackbarOpen(true);
      } finally {
        setSubmitLoading(false);
        setIsSubmitted(true);
        setTimeout(() => {
          setIsSubmitted(false);
        }, 3000);
      }
    }
  };

  const handleFileSelection = (e) => {
    const file = e.target.files[0];
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/webp",
      "image/bmp",
      "image/tiff",
      "image/svg+xml",
    ];

    const maxFileSize = 5 * 1024 * 1024; // 5MB in bytes

    if (file) {
      if (!allowedTypes.includes(file.type)) {
        setFormError((prevError) => ({
          ...prevError,
          SmartClinicImage: "Invalid file type. Please upload an image file.",
        }));
        setSelectedImage(null);
      } else if (file.size > maxFileSize) {
        setFormError((prevError) => ({
          ...prevError,
          SmartClinicImage: "File size exceeds 5MB. Please upload a smaller file.",
        }));
        setSelectedImage(null);
      } else {
        setFormError((prevError) => ({
          ...prevError,
          SmartClinicImage: "",
        }));
        setSelectedImage(file);

        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            setBase64(reader.result.toString());
          }
        };
        reader.readAsDataURL(file);
      }
    } else {
      setFormError((prevError) => ({
        ...prevError,
        SmartClinicImage: "Please upload a file.",
      }));
      setSelectedImage(null);
    }
  };

  const handleImageUpload = async (clinicId) => {
    try {
      const content = base64.split("base64,")[1];
      const response = await fetchData("lambdaAPI/SmartClinics/uploadSmartClinicImage", {
        smartClinicId: clinicId,
        smartClinicImage: content,
      });

      return response;
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const renderImagePreview = () => {
    if (selectedImage instanceof File) {
      return (
        <div className="mt-2">
          <img
            src={URL.createObjectURL(selectedImage)}
            alt="Preview"
            style={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
              borderRadius: "5px",
            }}
          />
        </div>
      );
    } else if (typeof selectedImage === "string" && selectedImage) {
      return (
        <div className="mt-2">
          <img
            src={`${imageUrl}${selectedImage}`} // if it's a filename from server
            alt="Current"
            style={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
              borderRadius: "5px",
            }}
          />
        </div>
      );
    }
    return null;
  };


  return (
    <>
      <div className="App">
        <form onSubmit={onSubmitHandler}>
          <div>
            <div>
              <div>
                {/* Smart Clinic Information */}
                <div className="col-md-12 mb-2">
                  <div className="card border-0 shadow-sm h-100">
                    <div
                      className="card-header p-3 text-white"
                      style={{
                        background:
                          "linear-gradient(to right, #1976D2, #0D47A1)",
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-circle me-3 p-2 d-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: "#ECEFF1",
                            width: "36px",
                            height: "36px",
                          }}
                        >
                          <i className="bx bx-clinic text-primary"></i>
                        </div>
                        <h5 className="mb-0 fw-bold text-white">
                          SMART CLINIC INFORMATION
                        </h5>
                      </div>
                    </div>
                    <div className="card-body p-4">
                      <div className="row">
                        {/* Smart Clinic Name */}
                        <div className="col-md-6 mb-4">
                          <label
                            htmlFor="SmartClinicName"
                            className="form-label fw-bold mb-2 text-start w-100"
                          >
                            Smart Clinic Name{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-clinic text-primary"></i>
                            </span>
                            <input
                              className="form-control py-2"
                              type="text"
                              id="SmartClinicName"
                              placeholder="Enter smart clinic name"
                              name="SmartClinicName"
                              maxLength={200}
                              value={formData.SmartClinicName}
                              onChange={onChangeHandler}
                            />
                          </div>
                          <small className="text-danger d-block text-start">
                            {formError.SmartClinicName}
                          </small>
                        </div>

                        {/* Smart Clinic Image */}
                        <div className="col-md-6 mb-4">
                          <label className="form-label fw-bold mb-2 text-start w-100">
                            Smart Clinic Image
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-image text-primary"></i>
                            </span>
                            <input
                              className="form-control py-2"
                              type="file"
                              name="SmartClinicImage"
                              accept="image/*"
                              onChange={(e) => handleFileSelection(e)}
                            />
                          </div>
                          {renderImagePreview()}
                          <small className="text-danger d-block text-start">
                            {formError.SmartClinicImage}
                          </small>
                        </div>

                        {/* Area */}
                        <div className="col-md-6 mb-4">
                          <label
                            htmlFor="Area"
                            className="form-label fw-bold mb-2 text-start w-100"
                          >
                            Area
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-map-alt text-primary"></i>
                            </span>
                            <input
                              className="form-control py-2"
                              type="text"
                              id="Area"
                              placeholder="Enter area"
                              name="Area"
                              maxLength={100}
                              value={formData.Area}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </div>

                        {/* Colony */}
                        <div className="col-md-6 mb-4">
                          <label
                            htmlFor="Colony"
                            className="form-label fw-bold mb-2 text-start w-100"
                          >
                            Colony
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-buildings text-primary"></i>
                            </span>
                            <input
                              className="form-control py-2"
                              type="text"
                              id="Colony"
                              placeholder="Enter colony"
                              name="Colony"
                              maxLength={100}
                              value={formData.Colony}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </div>

                        {/* Latitude */}
                        <div className="col-md-6 mb-4">
                          <label
                            htmlFor="Latitude"
                            className="form-label fw-bold mb-2 text-start w-100"
                          >
                            Latitude
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-map text-primary"></i>
                            </span>
                            <input
                              className="form-control py-2"
                              type="text"
                              id="Latitude"
                              placeholder="Enter latitude"
                              name="Latitude"
                              maxLength={50}
                              value={formData.Latitude}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </div>

                        {/* Longitude */}
                        <div className="col-md-6 mb-4">
                          <label
                            htmlFor="Longitude"
                            className="form-label fw-bold mb-2 text-start w-100"
                          >
                            Longitude
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-map-pin text-primary"></i>
                            </span>
                            <input
                              className="form-control py-2"
                              type="text"
                              id="Longitude"
                              placeholder="Enter longitude"
                              name="Longitude"
                              maxLength={50}
                              value={formData.Longitude}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Address Information */}
                <div className="col-md-12 mb-3">
                  <div className="card border-0 shadow-sm">
                    <div
                      className="card-header p-3 text-white"
                      style={{
                        background: "linear-gradient(to right, #1976D2, #0D47A1)",
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-circle me-3 p-2 d-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: "#ECEFF1",
                            width: "36px",
                            height: "36px",
                          }}
                        >
                          <i className="bx bx-map text-primary"></i>
                        </div>
                        <h5 className="mb-0 fw-bold text-white">
                          ADDRESS <span className="text-danger"></span>
                        </h5>
                      </div>
                    </div>
                    <div className="card-body p-3">
                      <div className="row">
                        {/* Address Line 1 */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="AddressLine1"
                            className="form-label fw-bold mb-1 text-start w-100"
                          >
                            Address-1 <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-building text-primary"></i>
                            </span>
                            <input
                              className="form-control py-2"
                              type="text"
                              id="AddressLine1"
                              placeholder="Enter Address"
                              name="AddressLine1"
                              maxLength={150}
                              value={formData.AddressLine1}
                              onChange={onChangeHandler}
                            />
                          </div>
                          <small className="text-danger d-block text-start">
                            {formError.AddressLine1}
                          </small>
                        </div>

                        {/* Address Line 2 */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="AddressLine2"
                            className="form-label fw-bold mb-1 text-start w-100"
                          >
                            Address-2
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-building-house text-primary"></i>
                            </span>
                            <input
                              className="form-control py-2"
                              type="text"
                              id="AddressLine2"
                              placeholder="Enter Address"
                              name="AddressLine2"
                              maxLength={150}
                              value={formData.AddressLine2}
                              onChange={onChangeHandler}
                            />
                          </div>
                        </div>

                        {/* State */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="StateId"
                            className="form-label fw-bold mb-1 text-start w-100"
                          >
                            State <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-map-alt text-primary"></i>
                            </span>
                            <select
                              className="form-select py-2"
                              name="StateId"
                              value={formData.StateId}
                              onChange={onChangeHandler}
                            >
                              <option value="">Select State</option>
                              {states.map((state) => (
                                <option
                                  key={state.StateId}
                                  value={state.StateId}
                                >
                                  {state.StateName}
                                </option>
                              ))}
                            </select>
                          </div>
                          <small className="text-danger d-block text-start">
                            {formError.StateId}
                          </small>
                        </div>

                        {/* District */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="DistrictId"
                            className="form-label fw-bold mb-2 text-start w-100"
                          >
                            District <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-map-pin text-primary"></i>
                            </span>
                            <select
                              className="form-select py-2"
                              id="DistrictId"
                              name="DistrictId"
                              value={formData.DistrictId || ""}
                              onChange={onChangeHandler}
                              disabled={!selectedStateId}
                            >
                              <option value="">Select District</option>
                              {districts.map((district) => (
                                <option
                                  key={district.DistrictId}
                                  value={district.DistrictId}
                                >
                                  {district.DistrictName}
                                </option>
                              ))}
                            </select>
                          </div>
                          <small className="text-danger d-block text-start">
                            {formError.DistrictId}
                          </small>
                        </div>

                        {/* City/Town */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="City"
                            className="form-label fw-bold mb-1 text-start w-100"
                          >
                            City/Town <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-city text-primary"></i>
                            </span>
                            <input
                              className="form-control py-2"
                              type="text"
                              id="City"
                              placeholder="Enter City Name"
                              name="City"
                              maxLength={75}
                              value={formData.City}
                              onChange={onChangeHandler}
                            />
                          </div>
                          <small className="text-danger d-block text-start">
                            {formError.City}
                          </small>
                        </div>

                        {/* Mandal */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="Mandal"
                            className="form-label fw-bold mb-2 text-start w-100"
                          >
                            Mandal
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-map text-primary"></i>
                            </span>
                            <select
                              className="form-select py-2"
                              id="Mandal"
                              name="Mandal"
                              value={formData.Mandal || ""}
                              onChange={onChangeHandler}
                              disabled={loading || !formData.DistrictId}
                            >
                              <option value="">Select Mandal</option>
                              {filteredMandals.map((mandal) => (
                                <option
                                  key={mandal.MandalId}
                                  value={mandal.MandalName}
                                >
                                  {mandal.MandalName}
                                </option>
                              ))}
                            </select>
                          </div>

                          {formData.DistrictId && (
                            <div className="mt-1">
                              <span
                                className="text-primary"
                                style={{
                                  fontSize: "0.75rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => setIsAddingMandal(true)}
                              >
                                <i className="bx bx-plus"></i> Add Mandal
                              </span>
                            </div>
                          )}

                          {/* Add Mandal Input Form */}
                          {isAddingMandal && (
                            <div className="mt-2 d-flex">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Enter Mandal Name"
                                value={newMandalName}
                                onChange={(e) => setNewMandalName(e.target.value)}
                              />
                              <button
                                type="button"
                                className="btn btn-primary btn-sm ms-2"
                                onClick={handleAddMandal}
                                disabled={loading}
                              >
                                Save
                              </button>
                              <button
                                type="button"
                                className="btn btn-secondary btn-sm ms-2"
                                onClick={() => setIsAddingMandal(false)}
                                disabled={loading}
                              >
                                Cancel
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Village */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="Village"
                            className="form-label fw-bold mb-2 text-start w-100"
                          >
                            Village
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-buildings text-primary"></i>
                            </span>
                            <select
                              className="form-select py-2"
                              id="Village"
                              name="Village"
                              value={formData.Village || ""}
                              onChange={onChangeHandler}
                              disabled={loading || !formData.Mandal}
                            >
                              <option value="">Select Village</option>
                              {filteredVillages.map((village) => (
                                <option
                                  key={village.VillageId}
                                  value={village.VillageName}
                                >
                                  {village.VillageName}
                                </option>
                              ))}
                            </select>
                          </div>

                          {formData.Mandal && (
                            <div className="mt-1">
                              <span
                                className="text-primary"
                                style={{
                                  fontSize: "0.75rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => setIsAddingVillage(true)}
                              >
                                <i className="bx bx-plus"></i> Add Village
                              </span>
                            </div>
                          )}

                          {/* Add Village Input Form */}
                          {isAddingVillage && (
                            <div className="mt-2 d-flex">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Enter Village Name"
                                value={newVillageName}
                                onChange={(e) =>
                                  setNewVillageName(e.target.value)
                                }
                              />
                              <button
                                type="button"
                                className="btn btn-primary btn-sm ms-2"
                                onClick={handleAddVillage}
                                disabled={loading}
                              >
                                Save
                              </button>
                              <button
                                type="button"
                                className="btn btn-secondary btn-sm ms-2"
                                onClick={() => setIsAddingVillage(false)}
                                disabled={loading}
                              >
                                Cancel
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Pincode */}
                        <div className="col-md-6 mb-3">
                          <label
                            htmlFor="Pincode"
                            className="form-label fw-bold mb-1 text-start w-100"
                          >
                            Pincode <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ backgroundColor: "#ECEFF1" }}
                            >
                              <i className="bx bx-code-alt text-primary"></i>
                            </span>
                            <input
                              className="form-control py-2"
                              type="text"
                              name="Pincode"
                              pattern="[0-9]{6}"
                              maxLength="6"
                              id="Pincode"
                              placeholder="eg: 123456"
                              onChange={onChangeHandler}
                              value={formData.Pincode}
                            />
                          </div>
                          <small className="text-danger">
                            {formError.Pincode}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit Form */}
              <div className="form-group" style={{ marginTop: "20px" }}>
                <div className="d-flex justify-content-between">
                  <button
                    className="btn btn-md btn-primary"
                    type="submit"
                    style={{
                      backgroundColor: "#5cb85c",
                      borderColor: "#5cb85c",
                      color: "#fff",
                      borderRadius: "5px",
                      padding: "8px 20px",
                      fontWeight: "bold",
                      cursor: "pointer",
                      minWidth: "100px",
                      minHeight: "40px",
                    }}
                  >
                    {submitLoading ? (
                      <div className="spinner-border text-white" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    ) : (
                      "Submit"
                    )}
                  </button>
                  {/* Cancel and Reset buttons on the right */}
                  <div>
                    <button
                      className="btn btn-md btn-primary"
                      type="button"
                      onClick={handleBackToView}
                      style={{
                        marginRight: "10px",
                        borderRadius: "5px",
                        padding: "8px 20px",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn btn-md btn-danger"
                      type="button"
                      style={{
                        borderRadius: "5px",
                        padding: "8px 20px",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                      onClick={resetForm}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>

              <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <Alert onClose={handleSnackbarClose} severity="success">
                  {snackbarMessage}
                </Alert>
              </Snackbar>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}